import { Component, computed, effect, inject, input, linkedSignal, resource } from '@angular/core';
import { LocationConsumptionGraph } from '../../components/location-consumption-graph/location-consumption-graph';
import { ConsumptionFilter, ConsumptionStore } from '../../../analysis/stores/consumption.store';
import { Api } from '../../../../core/clients/omni-core/api';
import {
  getLocationAggregateLoadCurve,
  GetLocationAggregateLoadCurve$Params,
} from '../../../../core/clients/omni-core/functions';
import { LoadingSpinner } from 'excellence-ui';
import { ErrorComponent } from '../../../../shared/components/error-component/error-component';

@Component({
  selector: 'app-location-details-consumption-page',
  imports: [LocationConsumptionGraph, LoadingSpinner, ErrorComponent],
  templateUrl: './location-details-consumption-page.html',
})
export class LocationDetailsConsumptionPage {
  private api = inject(Api);
  private consumptionStore = inject(ConsumptionStore);

  organizationId = input.required<string>();
  locationId = input.required<string>();

  protected data = computed(() => {
    const filter = this.filter();
    return filter ? this.consumptionStore.get(filter) : null;
  });

  protected initialFilter = resource<ConsumptionFilter, GetLocationAggregateLoadCurve$Params>({
    params: () => ({
      id: this.locationId(),
      oid: this.organizationId(),
    }),
    loader: async ({ params }) => {
      const res = await this.api.invoke(getLocationAggregateLoadCurve, params);

      const utilityType =
        res.consumptionElectricity || res.productionElectricity ? 'ELECTRICITY' : 'GAS';
      const direction =
        utilityType === 'ELECTRICITY'
          ? res.consumptionElectricity
            ? 'CONSUMPTION'
            : 'PRODUCTION'
          : res.consumptionGas
            ? 'CONSUMPTION'
            : 'PRODUCTION';

      return {
        date: new Date(),
        granularity: 'YEAR',
        view: 'line',
        data: {
          energyInterfaceID: '',
          locationID: params.id,
          direction,
          utilityType,
        },
      };
    },
  });
  protected filter = linkedSignal<ConsumptionFilter | null>(() =>
    this.initialFilter.hasValue() ? this.initialFilter.value() : null,
  );

  constructor() {
    effect(() => {
      const filter = this.filter();
      if (filter && !this.consumptionStore.get(filter)) {
        this.consumptionStore.load(filter);
      }
    });
  }

  protected onClickReload(filter: ConsumptionFilter | null) {
    if (filter) {
      this.consumptionStore.load(filter);
    }
  }
}
